import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { FaBars, FaTimes } from "react-icons/fa";
import logo from '../assets/logo.png'
import '../css/Navbar.css'

const Navbar = () => {

    const [isOpen, setIsOpen] = useState(false);

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    const closeSidebar = () => {
        setIsOpen(false);
    };

    return (
        <>
            <nav className='navbar navbar-expand-lg custom-navbar'>
                <div className='container-fluid d-flex justify-content-between align-items-center'>
                    {/* <Link to='/' className='navbar-brand text-white fw-bold'>Sky<span className='text-info'>Guard</span></Link> */}
                    {/* Logo */}
                    <Link className="navbar-brand text-white fw-bold" to="/">
                        <img src={logo} alt="logo" style={{ height: "40px" }} />
                    </Link>
                    <div className='d-none d-lg-flex gap-1 mx-5'>
                        <div className='mx-5 d-lg-flex gap-4 mt-2'>
                            <Link to='/' className='nav-link fw-bold'>Home</Link>
                            <Link to='/privacy-policy' className='nav-link fw-bold'>Privacy & Policy</Link>
                            <Link to='/careers' className='nav-link fw-bold'>Careers</Link>
                            <Link to='/contact' className='nav-link fw-bold'>Contact Us</Link>
                        </div>
                        <Link to='/admin-login'><button className="btn btn-custom bg-primary text-white">Login</button></Link>
                    </div>
                    {/* hamburger */}
                    <div className="d-lg-none text-black fs-2" onClick={toggleSidebar}>
                        {isOpen ? <FaTimes /> : <FaBars />}
                    </div>
                </div>
            </nav>
            {/* Sidebar Overlay */}
            {isOpen && (
                <div className="sidebar1-overlay" onClick={closeSidebar}></div>
            )}

            {/* Sidebar */}
            <div className={`sidebar1 ${isOpen ? "open" : ""}`}>
                <Link to='/' className="sidebar1-link mt-5" onClick={closeSidebar}>Home</Link>
                <Link to='/contact' className="sidebar1-link" onClick={closeSidebar}>Contact Us</Link>
                <Link to='/careers' className="sidebar1-link" onClick={closeSidebar}>Careers</Link>
                <Link to='/privacy-policy' className="sidebar1-link" onClick={closeSidebar}>Privacy & Policy</Link>
                <Link to='/admin-login'><button className="btn btn-custom bg-primary text-white">Login</button></Link>
            </div>
        </>
    )
}

export default Navbar